import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/api";
import { scrollToId } from "@/components/site/SmoothScroll";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-obsidian pt-20">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <img src="/img/logo-b.webp" alt="BAMF Battery Activated Multi Force Rescue and Tactical Saws" className="w-48 md:w-56" />
          </div>
          <div className="space-y-2 font-mono text-xs uppercase tracking-widest text-zinc-300">
            <p className="text-volt">Navigate</p>
            {[["arsenal", "Arsenal"], ["why-battery", "Why Battery"], ["ecosystem", "Ecosystem"], ["field", "In the Field"], ["contact", "Contact"]].map(([id, l]) => (
              <button key={id} data-testid={`footer-${id}-link`} onClick={() => scrollToId(id)} className="block hover:text-white">{l}</button>
            ))}
          </div>
          <div className="space-y-2 font-mono text-xs uppercase tracking-widest text-zinc-300">
            <p className="text-volt">Reach Us</p>
            <a href={CONTACT.phoneHref} className="block hover:text-white">{CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} className="block normal-case hover:text-white">{CONTACT.email}</a>
            <p>{CONTACT.location}</p>
          </div>
        </div>
      </div>
      <div className="mt-16 flex items-center gap-0">
        <div className="h-[3px] flex-1 bg-white/15" />
        <div className="h-[3px] w-40 bg-rescue" />
        <div className="h-[3px] flex-1 bg-white/15" />
      </div>
      <p aria-hidden="true" className="select-none text-center font-display font-black uppercase leading-[0.78] text-[34vw] text-volt/90 -mb-[4vw]" style={{ fontWeight: 900 }}>BAMF</p>
      <div className="relative border-t border-white/10 bg-obsidian">
        <div className="mx-auto flex max-w-[1500px] flex-col gap-3 px-5 py-6 md:flex-row md:items-center md:justify-between md:px-10 font-mono text-[11px] uppercase tracking-widest text-zinc-400">
          <p>© {year} BAMF Rescue and Tactical Saws</p>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-volt">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
